import { FC, useEffect, useState, useCallback, useRef } from 'react';
import { TextField, Tooltip, InputAdornment, IconButton } from "@mui/material";
import { Refresh } from "@mui/icons-material";
import { useAppSelector } from '../../store/hooks';
import { SearchIcon } from 'lucide-react';

interface FilterProps {
  type: string;
  filterHandler: (data: any) => void;
}

//Employee filters component.
const EmployeeFilters: FC<FilterProps> = ({ type, filterHandler }) => {
  const { selectedAccount } = useAppSelector(state => state.auth);
  const [filterQuery, setFilterQuery] = useState("");
  const debounceRef = useRef<NodeJS.Timeout | null>(null);

  const onResetClickHandler = () => {
    setFilterQuery('');
    filterHandler('');
  };

  const handleSearch = (value: string) => {
    setFilterQuery(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      const query = value.trim() ? `filter=${value.trim()}` : '';
      filterHandler(query);
    }, 800);
  };

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip title={'Reset Filter'}>
        <IconButton onClick={onResetClickHandler}
          style={{ marginRight: '15px', marginLeft: '5px', color: '#488dff', backgroundColor: '#fff', border: '3px solid #e9ecf1' }}
          size='small' ><Refresh /></IconButton>
      </Tooltip>
      <TextField className='c-text-field-3'
        variant="standard"
        style={{ width: 350 }}
        size='small'
        value={filterQuery}
        placeholder='Search Name, Email, Employee ID ...'
        onChange={(e) => handleSearch(e.target.value)}
        InputProps={{
          disableUnderline: true,
          startAdornment: <InputAdornment position="start"><SearchIcon style={{ marginTop: -3 }} size={20} /></InputAdornment>,
          style: {
            fontSize: 14,
            fontWeight: 'normal',
          },
        }}
      />
    </div>
  );
}

export default EmployeeFilters;
